module.exports = __webpack_public_path__ + "img/20191112152549866.c95e6aeb.jpg";